import { createClient } from 'contentful';

// Create the Contentful client
export const contentfulClient = createClient({
  space: process.env.REACT_APP_CONTENTFUL_SPACE_ID!,
  accessToken: process.env.REACT_APP_CONTENTFUL_ACCESS_TOKEN!,
});

// TypeScript interfaces for content types
export interface ImageAssetFields {
  title: string;
  image: {
    fields: {
      file: {
        url: string;
      };
    };
  };
  altText: string;
  category?: string;
}

export interface PageContentFields {
  sectionName: string;
  title?: string;
  subtitle?: string;
  description?: string;
  longDescription?: string;
  buttonText?: string;
  buttonLink?: string;
}

export interface NavigationItem {
  text: string;
  href: string;
}

export interface NavigationFields {
  menuName: string;
  menuItems: NavigationItem[];
}

export interface OfferFields {
  title: string;
  description: string;
  image: {
    fields: {
      file: {
        url: string;
      };
    };
  };
  primaryButtonText?: string;
  secondaryButtonText?: string;
}
